//? Usar este customHook para obtener los events de calendarios

import { useEffect, useState } from "react";
import { createEvent } from "../helpers/events";

export const useScheduleEvents = (name, calendars) => {
    const [events, setEvents] = useState([]);
    const [calendar, setCalendar] = useState({
        week_schedule: [],
        min: 7,
        max: 23,
    });

    useEffect(() => {
        setEvents(getOriginalListEvents());
    }, [calendar]);

    useEffect(() => {
        if (name) {
            const c = calendars.find((c) => c.name === name);
            setCalendar(c);
        }
    }, [name, calendars]);

    const getOriginalListEvents = () => {
        let eventList = [];
        calendar?.week_schedule?.forEach(({ date: date_event, schedule }) => {
            schedule
                .filter((sc) => !!sc)
                .forEach((item) => {
                    eventList.push(createEvent(item, date_event));
                });
        });

        // setOriginalEvents(eventList);

        return eventList;
    };

    return {
        events,
        calendar,
    };
};
